module.exports = __webpack_public_path__ + "img/zweiterWeihnachtsbaum.055d0ef1.jpg";